// src/components/ProjectDetails/index.js

import Latexer from './projects/Latexer';
import UPark from './projects/UPark';
import Spotifyer from './projects/Spotifyer';

export const projectsData = [Latexer, UPark, Spotifyer];

export { default as ProjectDetail } from './ProjectDetail';